//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'
import { ScopeBaseGrid } from '../common/common.base.grid.controller'

import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { ConfigHelper } from '../../helpers'

import { ORDER_SERVICE_NAME, ORDER_COMPLETE_SERVICE_NAME, OrderService, OrderCompleteService } from '../../services/order'
import { SERVICES_MODULE_NAME } from './../../services'
import {
    $STATE_SERVICE_PROVIDER_NAME,
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    SYSTEM_SERVICE_PROVIDER_NAME,
    SYSTEM_SERVICE_NAME,
    SystemServiceProvider,
    SystemService
} from '../../services/system'

import {
    USER_SESSION_SERVICE_NAME,
    USER_SESSION_SERVICE_PROVIDER_NAME,
    UserSessionService,
    UserSessionServiceProvider
} from '../../services/user-session'

import { OrderController } from './orders.controller'
import { COMPONENTS_MODULE_NAME, DETAILS_DIRECTIVE_NAME } from './components'

//#region Asset Imports

import * as TEMPLATE from './orders.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'OrdersController'
const MENU_INDEX = 10
const MODULE_NAME: string = 'simax.orders'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'ORDER_NAME'
const STATE_NAME: string = 'orders'
const STATE_URL: string = '/orders'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [
    commonModule,
    apiModule,
    SERVICES_MODULE_NAME,
    COMPONENTS_MODULE_NAME
])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    ORDER_SERVICE_NAME,
    ORDER_COMPLETE_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    (
        $scope: ScopeBaseGrid,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        orderService: OrderService,
        orderCompleteService: OrderCompleteService,
        systemService: SystemService,
        userSessionService: UserSessionService
    ) => new OrderController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        orderService,
        orderCompleteService,
        systemService,
        userSessionService,
        OrderService.REFERENCE_TYPE,
        OrderService.SIMAX_MODULE_NAME
    )])


module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionServiceProvider: UserSessionServiceProvider,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Order_IdPackage',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionServiceProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.ORDER_LIST)
                && !loggedOperator.hasPermission(Activity.ORDER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OrderModule)) {
                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.ORDER),
                    'orders',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME